import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { router } from '~/modules'
import { RouterProvider } from 'react-router-dom'
import { useAuthRequired } from './hooks'
import { useAuth0 } from '@auth0/auth0-react'

const App = function App() {
  const { isLoading: authLoading } = useAuth0()
  const pathname = window.location.pathname
  const isLogoutPage = pathname === '/logout'
  
  // Skip auth requirement for logout page
  const routeAuth = isLogoutPage ? true : useAuthRequired()
  const isAuthenticated = isLogoutPage ? true : routeAuth

  const loading = (
    <Backdrop invisible open>
      <CircularProgress color='primary' />
    </Backdrop>
  )

  // Show loading while auth is initializing (except on logout page)
  if (authLoading && !isLogoutPage) {
    return loading
  }

  return isAuthenticated ? <RouterProvider router={router} /> : loading
}

export default App

